
import $ from 'jquery';

class showImages {

  showProductPictures(event) {
    var href = event.target.dataset.href;
    var windowFeatures = 'width=1000px,height=800px,scrollbars=1,resizable=1';
    window.open(href, 'showAllPictures', windowFeatures);
  }

  init(){
    this._bindEvents();
  }

  _bindEvents(){
    const self = this;
    $('.all-images').click(function(ev){
      self.showProductPictures(ev);
    });
  }
}
module.exports = new showImages();
